import { render, staticRenderFns } from "./CloseCoupon.vue?vue&type=template&id=8b85554a&scoped=true"
import script from "./CloseCoupon.vue?vue&type=script&lang=js"
export * from "./CloseCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b85554a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b85554a')) {
      api.createRecord('8b85554a', component.options)
    } else {
      api.reload('8b85554a', component.options)
    }
    module.hot.accept("./CloseCoupon.vue?vue&type=template&id=8b85554a&scoped=true", function () {
      api.rerender('8b85554a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/list/modules/CloseCoupon.vue"
export default component.exports